import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "accountType", "companyDetails", "companyOnly",
    "primaryAddress", "primaryOwner", "uniqueOwner", "percentOwnership",
    "person", "additionalOwners",
  ]

  processUniqueOwner(event) {
    let currentPerson = event.currentTarget
      .closest("[data-stripe-accounts-target~='person']")
    let currentPercent = currentPerson
      .querySelector("[data-stripe-accounts-target~='percentOwnership']")
    let currentPercentContainer = currentPercent
      .closest("[data-stripe-accounts-target~='percentOwnershipContainer']")


    if ( event.currentTarget.checked ) {
      currentPercent.value = 100
    } else {
      currentPercent.value = 0
    }

    //currentPercentContainer.classList.toggle("invisible", event.currentTarget.checked)
  }

  changeAccountType() {
    if ( this.changedToCompany() ) {
      this.showCompanyFields()
    } else if ( this.changedToIndividual() ) {
      this.hideCompanyFields()
    }
  }

  changedToCompany() {
    return this.accountTypeTarget.value == "company"
  }

  changedToIndividual() {
    return this.accountTypeTarget.value == "individual"
  }

  showCompanyFields() {
    this.companyOnlyTargets.forEach(function(el){
      el.classList.remove("d-none")
    })
  }

  hideCompanyFields() {
    this.companyOnlyTargets.forEach(function(el){
      el.classList.add("d-none")
    })
  }
}
